import { useQueryStates, parseAsIndex, parseAsInteger } from 'nuqs'

export const useIndeedFlexShiftIssuesPaginationQueryState = () => {
  const queryStates = useQueryStates(
    {
      pageIndex: parseAsIndex.withDefault(0),
      pageSize: parseAsInteger.withDefault(50),
    },
    {
      urlKeys: {
        pageIndex: 'page',
        pageSize: 'page-size',
      },
    }
  )

  return queryStates
}
